import React from 'react'
import Icon from '@ant-design/icons'

const RightSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 6 8" fill="currentColor">
    <path
      d="M4.92617 4.51901L1.14392 7.82796C0.69891 8.21847 2.50453e-07 7.9011 2.31023e-07 7.30844L1.40648e-08 0.690533C-0.000113711 0.557896 0.0380071 0.428037 0.109797 0.316507C0.181588 0.204978 0.284005 0.116507 0.404783 0.061687C0.525561 0.00686738 0.659581 -0.0119772 0.790794 0.00741191C0.922006 0.0268001 1.04485 0.0835995 1.14461 0.171008L4.92548 3.47996C4.99959 3.54472 5.05898 3.62458 5.09968 3.71419C5.14037 3.80379 5.16143 3.90107 5.16143 3.99949C5.16143 4.0979 5.14037 4.19517 5.09968 4.28478C5.05898 4.37439 4.99959 4.45425 4.92548 4.51901L4.92617 4.51901Z"
    />
  </svg>
)

const RightIcon = props => <Icon component={RightSvg} {...props} />

export default RightIcon